import template from './template.html';

export default {
    parent: 'ApplicationLayout',
    template
};



// WEBPACK FOOTER //
// ./src/app/layouts/regular/index.js